import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../encapsulation';
import { UBXSnack, UBXSnackPosition } from '../../models';
import { UBXSnackbarService } from '../../services';

@Component({
    selector: 'ubx-snackbar',
    templateUrl: './snackbar.component.html',
    host: { class: 'ubx-snackbar flx f-fd:c p:fx cvr:a mg:20 pe:n zi:100' },
    encapsulation,
    animations: [
        trigger('animate', [
            transition(':enter', [
                style({ opacity: 0 }), animate('0.5s ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }), animate('0.5s ease-out', style({ opacity: 0 }))
            ]),
        ]),
        trigger('leave', [
            transition(':leave', [
                style({ opacity: 1 }), animate('0.5s ease-out', style({ opacity: 0 }))
            ]),
        ]),
    ],
})
export class UBXSnackbarComponent implements OnInit {
    snack: UBXSnack;
    timeOut: any;

    constructor(
        private snackbarService: UBXSnackbarService,
    ) {}

    ngOnInit() {
        this.getSnack();
    }

    private getSnack() {
        this.snackbarService.getSnack().subscribe((snack: UBXSnack) => {
            this.removeSnack();
            if (snack) {
                this.snack = snack;
                if (snack.timer) {
                    this.timeOut = setTimeout(() => this.snack = undefined, snack.timer);
                }
            }
        });
    }

    removeSnack() {
        clearTimeout(this.timeOut);
        this.snack = undefined;
    }

    setPosition(position: UBXSnackPosition): string {
        let align: string;
        switch (position) {
            case UBXSnackPosition.Top:
                align = 'fs';
                break;
            case UBXSnackPosition.Bottom:
                align = 'fe';
                break;
        }
        return align;
    }
}
